import React from "react";

export const Signal = () => {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.2944 16.931C3.24995 15.8865 2.42144 14.6466 1.85619 13.2819C1.29093 11.9173 1 10.4547 1 8.97759C1 7.50051 1.29093 6.03789 1.85619 4.67325C2.42144 3.3086 3.24994 2.06866 4.2944 1.0242"
        stroke="#EFF0F6"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.78004 14.4457C6.06198 13.7276 5.49238 12.8752 5.10377 11.937C4.71515 10.9988 4.51514 9.99322 4.51514 8.97773C4.51514 7.96224 4.71515 6.95669 5.10376 6.01849C5.49238 5.0803 6.06197 4.22784 6.78004 3.50978"
        stroke="#EFF0F6"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="11.5001"
        cy="8.8019"
        r="3.21792"
        stroke="#EFF0F6"
        strokeWidth="2"
      />
      <path
        d="M18.7056 16.9758C19.7501 15.9314 20.5786 14.6914 21.1438 13.3268C21.7091 11.9621 22 10.4995 22 9.02245C22 7.54537 21.7091 6.08275 21.1438 4.71811C20.5786 3.35346 19.7501 2.11352 18.7056 1.06906"
        stroke="#EFF0F6"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.22 14.4905C16.938 13.7725 17.5076 12.92 17.8962 11.9818C18.2848 11.0436 18.4849 10.0381 18.4849 9.02259C18.4849 8.0071 18.2848 7.00155 17.8962 6.06336C17.5076 5.12516 16.938 4.2727 16.22 3.55464"
        stroke="#EFF0F6"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
